import ToastLib, { ToastShowParams } from 'react-native-toast-message';

const libShow = ToastLib.show;

export const Toast = Object.assign(ToastLib, {
	show: ({ delay, ...options }: ToastShowParams & { delay?: number }) => {
		setTimeout(() => libShow(options), delay);
	},
});
